import type {
  PintxoAccessibilityFunction,
  PintxoAccessibilityTag,
  PintxoConfig,
} from './types'

export type { PintxoConfig, PintxoAccessibilityTags } from './types'

let pintxoConfig: PintxoConfig = {
  accessibility: {
    tags: {
      close: 'Close',
      collapse: 'Collapse',
      expand: 'Expand',
      next: 'Next',
      previous: 'Previous',
      slides: 'Slides',
    },
    functions: {
      getSlideOfTotal: (index: number, pages: number) => () =>  `Slide ${index + 1} of ${pages + 1}`,
      getDotReference: (index: number) => () =>  `Slide ${index + 1}`,
    },
  },
  translator: (key: string) => key,
}

export const setPintxoConfig = (config: Partial<PintxoConfig>) => {
  pintxoConfig = { ...pintxoConfig, ...config }
}

export const getPintxoConfig = (): PintxoConfig => pintxoConfig
export const getAccessibilityTag = (key: PintxoAccessibilityTag): string => {
  return pintxoConfig.translator(pintxoConfig.accessibility.tags[key])
}

export const getAccessibilityFunction = (
  key: PintxoAccessibilityFunction
   //eslint-disable-next-line @typescript-eslint/no-explicit-any
): ((...args: any[]) => () => string) => {
  return pintxoConfig.accessibility.functions[key]
}
